export default {
  Region: 'ap-northeast-1',
  UserPoolId: 'ap-northeast-1_affGEKtFM',
  ClientId: '7enckrm6qg4lqjs3dpbab7jhv9',
  IdentityPoolId: 'ap-northeast-1:85e6cb1d-fe6e-41d8-99c5-7a84aed9d783'
}



// WEBPACK FOOTER //
// ./src/config.js